import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useGetDocumentTree = (id: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['Document-tree', id],
        queryFn: () => api.document.getDocumentTree(id),
        enabled: enabled && !!id,
        meta: {
            skipGlobalErrorHandler: true,
        },
    })
}
